/* global MktoForms2, Munchkin,  */

export default class MarketoForm {
    /**
     * Creates an instance of a Marketo Form (hidden) to send values to the Marketo API.
     * @param {number} mktoFormId Valid Marketo form id e.g. 1001
     */
    constructor(mktoFormId: number) {
        this.mktoForm = null;
        this.mktoFormId = mktoFormId;
    }

    mktoForm: IMktoForm;
    mktoFormId: number;

    /**
     * Initializes a Marketo form, binding it to its Marketo form functions,
     * it also attaches a submit handler for the EHM form.
     */
    init() {
        if (!this.mktoFormId) {
            return;
        }

        if (typeof window.MktoForms2 === 'undefined') {
            console.error('Marketo scripts are not loaded/ready');
            return;
        }

        // Get the Marketo Form (previous ehm forms could have created an instance with the same marketoId)
        this.mktoForm = window.MktoForms2.getForm(this.mktoFormId);
        const formCreated = document.getElementById(`mktoForm_${this.mktoFormId}`);

        // In case the Marketo form does not exist yet, we load it and initialize munchkin
        if (!this.mktoForm && !formCreated) {
            const mktoHiddenForm = document.createElement('FORM');
            mktoHiddenForm.id = `mktoForm_${this.mktoFormId}`;
            mktoHiddenForm.classList.add('hidden');
            const quarantine = document.querySelector('.marketo-quarantine');
            quarantine?.appendChild(mktoHiddenForm);

            window.MktoForms2.loadForm(
                'https://app-ab41.marketo.com/',
                process.env.GATSBY_MKTO_MUNCHKIN_ID,
                this.mktoFormId,
                (form) => {
                    this.mktoForm = form;
                }
            );

            window.Munchkin.init(process.env.GATSBY_MKTO_MUNCHKIN_ID, {
                customName: 'Marketo-Form-Submission',
                wsInfo: 'j1RR',
            });
        }
    }

    /**
     * Handles the Marketo form submission, it takes the ehm fields values and map them to the Marketo one.
     */
    mktoFormSubmit(
        email: string,
        affiliateID: string,
        emailStatus?: string,
        leadType?: string,
        leadStatus?: string
    ) {
        if (!this.mktoFormId || !email) {
            return;
        }

        if (typeof window.MktoForms2 === 'undefined') {
            console.error('Marketo scripts are not loaded/ready');
            return;
        }

        if (!this.mktoForm) {
            this.mktoForm = window.MktoForms2.getForm(this.mktoFormId);
        }

        // Could happen that mktoForm could not be found even after the previous check
        if (!this.mktoForm) {
            return;
        }

        this.mktoForm.onSuccess(() => {
            // Return false to prevent the submission handler from taking the lead to the follow up url
            return false;
        });

        const affiliateIDmktoFormID = 'affiliateID' + this.mktoFormId.toString();

        this.mktoForm.addHiddenFields({ Email: email });
        this.mktoForm.addHiddenFields({ [affiliateIDmktoFormID]: affiliateID });
        if (emailStatus) this.mktoForm.addHiddenFields({ EMAIL_STATUS: emailStatus });
        if (leadType) this.mktoForm.addHiddenFields({ LeadType: leadType });
        if (leadStatus) this.mktoForm.addHiddenFields({ LeadStatus: leadStatus });
        this.mktoForm.submit();
    }
}
